import { normalizeText, convertNotionalToBRL } from './convertNotionalToBRL.js'

export function isConverted(row) {
  return normalizeText(row.status) === 'DEAL'
}

// Sum of BRL notional for converted rows only (DEAL).
// effectiveSpotByRow must come from createEffectiveSpotMap(allRows).
export function calculateConvertedVolumeBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    if (!isConverted(row)) return total

    const amount = convertNotionalToBRL(row, effectiveSpotByRow.get(row))

    if (amount == null) return total

    return total + amount
  }, 0)
}

// Quantas linhas foram convertidas (DEAL).
export function countConverted(rows) {
  return rows.reduce((n, row) => (isConverted(row) ? n + 1 : n), 0)
}

// Ticket medio convertido: volume BRL dividido pela contagem do MESMO universo.
export function calculateConvertedTicketBRL(rows, effectiveSpotByRow) {
  const count = countConverted(rows)
  return count > 0 ? calculateConvertedVolumeBRL(rows, effectiveSpotByRow) / count : 0
}
